// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"539":"96277de4","655":"acd54fed"}[chunkId] + ".chunk.css";
};